import React from 'react'
import { Link } from "react-router-dom";
export const FooterFollowUs = () => {
  return (
    <div className="footFollow">
      <h4>Follow Us</h4> 
      <div className="footerSocial">
        <ul>
            <li><Link to="#">Facebook</Link></li>
            <li><Link to="#">Instagram</Link></li>
            {/* <li><Link to="#">Dribbble</Link></li>
            <li><Link to="#">Linkedin</Link></li> */}
        </ul>
      </div>
    </div>
  )
}
